import { apiQuery } from '../';

export const introQueueApi = apiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      addToIntroQueue: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          return {
            url: '/intros/bulk/queue',
            method: 'post',
            data: {
              intros: payload,
            },
          };
        },
      }),
      removeFromQueue: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          return {
            url: `/intros/bulk/queue`,
            method: 'delete',
            params: {
              id: payload,
            },
          };
        },
      }),
      getIntroFromQueue: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          const { introId, subject, body } = payload;
          return {
            url: `/intros/${introId}/request_from_queue`,
            method: 'patch',
            data: {
              requester_subject: subject,
              requester_html: body,
            },
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useAddToIntroQueueMutation,
  useRemoveFromQueueMutation,
  useGetIntroFromQueueMutation,
} = introQueueApi;
